export var MapAppMode;
(function (MapAppMode) {
    MapAppMode[MapAppMode["PQ4CAST"] = 1] = "PQ4CAST";
    MapAppMode[MapAppMode["POWMON"] = 2] = "POWMON";
    MapAppMode[MapAppMode["PQWEB"] = 3] = "PQWEB";
    MapAppMode[MapAppMode["UNKNOWN"] = -1] = "UNKNOWN";
})(MapAppMode || (MapAppMode = {}));
